<template>
  <v-app class="bg-grey-lighten-4">
    <v-layout>
      <menuComponent :key="this.messageKey" />
      <v-main>
        <router-view @cartChange="this.messageKey++" @confirmed="this.messageKey++" />
      </v-main>
    </v-layout>
    <footerComponent />
  </v-app>
</template>

<script>
import menuComponent from "@/components/nav/menuComponent";
import footerComponent from "@/components/footerComponent.vue";
import { keywords } from "@/composables/keywords";
import { applySeo } from "@/composables/seo";

export default {
  name: "DefaultView.vue",
  components: {
    menuComponent,
    footerComponent,
  },
  data () {
    return {
      rail: true,
      mobile_drawer: false,
      data: null,
      search: '',
      messageKey: 0,
      defaultSeo: {
        title: "HANDLE Marketplace",
        description: "All of your needs in one place.",
        keywords: "",
      },
    }
  },
  computed: {

  },
  mounted() {
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
    this.messageKey++;
    const cachedKeywords = localStorage.getItem("keywords");
    this.defaultSeo.keywords = cachedKeywords && cachedKeywords !== "undefined" ? cachedKeywords : "";
    applySeo(this.defaultSeo);
    this.keywords();
  },
  methods: {
    async keywords(){
      const results = await keywords(this.$csrf_url, this.$main_api);
      this.defaultSeo.keywords = results || this.defaultSeo.keywords;
      applySeo(this.defaultSeo);
    },
  }
}
</script>

<style>
@import "./assets/base.css";
</style>